//******************************************************************************
/**
 * @fileoverview detectMime mimeType自動識別（png、webp専用）
 * @author KITAO Kaoru <kaoru@kitao.net>
 * @version 0.1.0
 * @since 2026-03-06
 * @copyright 2026 KITAO Kaoru
 * @license MIT
 * * @history
 * - 2026.03.06 v0.1.0 リリース
 */

//******************************************************************************
/**
 * バッファからmimeTypeを自動識別する
 * @param {ArrayBuffer} buffer バッファ
 * @returns {"image/png" | "image/webp"}
 * @throws {Error} 想定外フォーマットの場合
 */
function detectMime(buffer) {
	//--------------------------------------------------------------------------
	// 先頭12バイトを取得
	const bytes = new Uint8Array(buffer, 0, 12);
	//--------------------------------------------------------------------------
	// バイト列検証
	if (
		bytes[0] === 0x89 && bytes[1] === 0x50
		&& bytes[2] === 0x4E && bytes[3] === 0x47) {
		// pngの場合
		return "image/png";
	} else if (
		bytes[0] === 0x52 && bytes[1] === 0x49
		&& bytes[2] === 0x46 && bytes[3] === 0x46
		&& bytes[8] === 0x57 && bytes[9] === 0x45
		&& bytes[10] === 0x42 && bytes[11] === 0x50
	) {
		// webpの場合の場合
		return "image/webp";
	} else {
		// 上記以外の場合
		throw new Error("Unsupported image format.");
	}
}

//******************************************************************************
// export
export { detectMime };
